import React from 'react'
import Logo from '../assets/logo.jpeg';
import { Link } from 'react-router-dom';
import ScrollToTop from 'react-scroll-to-top';

const Footer = () => {
    return (
        <>

            <ScrollToTop smooth className='scroll-to-top' viewBox="0 0 448 512"
                svgPath="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" />

            <footer className='footer-bg py-4'>
                <div className='container'>

                    <div className='row my-5'>

                        <div className='col-lg-4 col-md-6 col-12 my-2'>
                            <img src={Logo} style={{ height: '5em' }} className='rounded' alt='footer logo' />
                            <p className='my-3 text-muted'>We are dedicated trust focused on empowering individuals through skill development, education, and community welfare initiatives.</p>
                            <Link className='footer-text me-3'><i className="fa-brands fa-facebook-f"></i></Link>
                            <Link className='footer-text me-3'><i className="fa-brands fa-linkedin-in"></i></Link>
                            <Link className='footer-text me-3'><i className="fa-brands fa-instagram"></i></Link>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 my-2'>
                            <p className='sec-heading5'>Important</p>
                            <Link className='footer-text' to='/'>Home</Link><br />
                            <Link className='footer-text' to='/about'>About</Link><br />
                            <Link className='footer-text' to='/donation'>Donation</Link><br />
                            <Link className='footer-text' to='/gallery'>Gallery</Link><br />
                            <Link className='footer-text' to='/skill-development'>Skill Development</Link><br />
                            <Link className='footer-text' to='/careers'>Careers</Link><br />
                            <Link className='footer-text' to='/privacy-policy'>Privacy Policy</Link><br />
                            <Link className='footer-text' to='/contact'>Contact</Link>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 my-2'>
                            <p className='sec-heading5'>Contact</p>
                            <Link className='footer-text'>9599332740</Link><br />
                            <Link className='footer-text'>8178042539</Link><br />
                            <Link className='footer-text'>info@anvifoundation.com</Link>
                            <p className='footer-text'>Location: H No. 247, Kasturipur Kasturi, Holagarh Soraon, Allahabad, Uttar Pradesh, 212503</p>
                        </div>

                    </div>
                    {/* row ends */}

                    <hr />

                    <p className='text-muted'>&copy; Anvi Foundation All Rights Reserved. Developed By
                        <Link className='footer-text' to='https://dectwinservices.com' target='_blank'> Dectwin Services Pvt Ltd</Link></p>

                </div>
            </footer>

        </>
    )
}

export default Footer
